

import React, { useState } from 'react';
import './Calculator.css';

const Trigonometry = () => {
  const [number, setNumber] = useState('');
  const [operation, setOperation] = useState('sine');
  const [result, setResult] = useState(null);

  const handleNumberChange = (e) => {
    setNumber(e.target.value);
  };

  const handleOperationChange = (e) => {
    setOperation(e.target.value);
  };

  const calculateResult = () => {
    const num = parseFloat(number);
    if (isNaN(num)) return;

    let res;
    switch (operation) {
      case 'sine':
        res = Math.sin(num);
        break;
      case 'cosine':
        res = Math.cos(num);
        break;
      case 'tangent':
        res = Math.tan(num);
        break;
        case 'arcsine':
        res = Math.asin(num);
        break;
      case 'arccosine':
        res = Math.acos(num);
        break;
        case 'arctangent':
        res = Math.atan(num);
        break;
      default:
        res = null;
    }
    setResult(res);
  };

  return (
    <div className="calculator">
      <h1>Find out Trigonometry Functions</h1>
      <div>
        <label>
          Number:
          <input type="number" value={number} onChange={handleNumberChange} />
        </label>
      </div>
      <div>
        <label>
          Operation:
          <select value={operation} onChange={handleOperationChange}>
            <option value="sine">sin()</option>
            <option value="cosine">cos()</option>
            <option value="tangent">tan()</option>
            <option value="arcsine">asin()</option>
            <option value="arccosine">acos()</option>
            <option value="arctangent">atan()</option>
          </select>
        </label>
      </div>
      <button onClick={calculateResult}>Calculate</button>
      {result !== null && <div className="result">Result: {result}</div>}
    </div>
  );
};

export default Trigonometry;
